module.exports = __webpack_public_path__ + "static/img/gxhdz55.26ea9ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gxhdz55.png
// module id = o9mw
// module chunks = 73